import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuth } from "../auth";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context, location }) => {
    if (context.auth.isLoading) return;

    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
    throw redirect({
      to: "/dashboard",
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const auth = useAuth();

  useEffect(() => {
    const jsdWidget = document.querySelector("#jsd-widget");
    if (jsdWidget instanceof HTMLElement) {
      jsdWidget.style.visibility = auth.isAuthenticated ? "visible" : "hidden";
    }
  }, [auth]);

  return <Outlet />;
}
